import type { ActionEntity } from 'components/IAP/hooks/useScopedActionForm';
import type { GetOrgActionResponse } from 'components/IAP/hooks/orgActionHooks';
import type { PlanLibraryTask } from 'hooks/planLibrary/planLibraryHooks';
import { DEFAULT_ACTION_CLASSIFICATION } from 'components/IAP/actionClassification';
import { DEFAULT_ACTION_PRIORITY } from 'components/IAP/ICSConstants';

export function emptyPlanLibraryTask(): Omit<PlanLibraryTask, 'id'> {
  return {
    name: '',
    description: '',
    status: 'Planned',
    priority: DEFAULT_ACTION_PRIORITY,
    classification: DEFAULT_ACTION_CLASSIFICATION,
    checklist: [],
    assignee_kind: null,
    assignee_id: null,
    poc: null,
    briefed_poc: false,
    start_date: null,
    target_date: null,
    geolocation: null,
    symbology: null,
    aor_id: null,
    reporting_location: null,
    requested_arrival_time: null,
    resource_requirements: [],
    resource_requirements_na: false,
    hazards: [],
    attachments: [],
    depends_on: [],
  };
}

export function planTaskToActionEntity(
  task: PlanLibraryTask,
  aorName?: string | null
): ActionEntity {
  return {
    id: task.id,
    action_id: task.id,
    name: task.name,
    description: task.description,
    checklist: task.checklist,
    poc: task.poc,
    briefed_poc: task.briefed_poc,
    start_date: (task.start_date as Date | null) ?? null,
    target_date: (task.target_date as Date | null) ?? null,
    actual_date: null,
    status: task.status,
    priority: task.priority,
    assignee_kind: task.assignee_kind,
    assignee_id: task.assignee_id,
    geolocation: task.geolocation,
    aor_id: task.aor_id,
    aor_name: aorName ?? null,
    classification: task.classification,
    symbology: task.symbology,
    reporting_location: task.reporting_location,
    requested_arrival_time: task.requested_arrival_time,
    resource_requirements: task.resource_requirements,
    resource_requirements_na: task.resource_requirements_na,
    hazards: task.hazards,
    attachments: task.attachments,
    depends_on: task.depends_on,
    archived: false,
    group_guid: '',
    user_guid: '',
    version: 1,
    timestamp: new Date(),
  } as GetOrgActionResponse;
}
